module.exports = __webpack_public_path__ + "media/images/championship__iconPickTeam-cd702d71d8f28b78e5e80349eb2b8eb3.png";